import styled from 'styled-components';

export default styled.div`
  clear: both;
  font-weight: 500;
`;
